<template>
  <div>
    <div class="login">
      <div class="main">
        <img src='../assets/images/common/loading.gif' alt="" width="150" class="animate__animated animate__bounceOut">
        <div class="text animate__animated animate__bounceOut">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { browserUrl } from '@/utils/index.js'
import { loginOut } from '@/api/login'
export default {
  components: {
  },
  data() {
    return {
      browserUrl:browserUrl
    }
  },
  mounted() {
    let userInfo = {
      yhid: Number(this.$route.query.yhid),
      zhid: Number(this.$route.query.zhid),
      realname: this.$route.query.realname,
      jsmc: this.$route.query.jsmc,
      xb: Number(this.$route.query.xb),
      zhmc: this.$route.query.zhmc,
      yhm: this.$route.query.yhm,
    }
    // 地址栏没有携带参数，点击退出登录进的login页
    if(!userInfo.zhid || !userInfo.yhid){
      loginOut({yhid: this.$store.state.userInfo.yhid + ''}).then(res => {
        if(res.success){
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('userInfo')
          window.location.href = this.browserUrl
        } else {
          this.$message.warning(res.resultDesc)
          window.location.href = this.browserUrl
        }
      })
    } else {
      sessionStorage.setItem('yycdid', this.$route.query.yycdid)
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
      sessionStorage.setItem('token', decodeURIComponent(this.$route.query.token))
      this.$store.commit("setYycdid", Number(this.$route.query.yycdid))
      this.$store.commit("setInfo", userInfo)
      this.$store.commit("setToken", decodeURIComponent(this.$route.query.token))
      if(userInfo.jsmc == '家长'){
        setTimeout(() => {
          this.$router.replace({ name: 'parent' })
        }, 2000)
      } else {
        setTimeout(() => {
          this.$router.replace({ name: this.$route.query.jsmc === '学生' ? 'home' : 'myClass' })
        }, 2000)
      }
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.login {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .main {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    img {
      animation-delay: 2s;
    }
    .text {
      color: #333;
      font-size: 32px;
      padding-top: 30px;
      animation-delay: 2s;
    }
  }
}
</style>



